import React from 'react';
import { momentParseDate } from '../../helpers';

interface UserBudgetFormProps {
    createdBy?: string;
    createdAt?: string;
    updatedBy?: string;
    updatedAt?: string;
    status?: string;
    statusValue?: string; // Valor del estado para determinar el color del badge
}

const DefaultCreatedModifiedUserForm = ({
    createdBy,
    createdAt,
    updatedBy,
    updatedAt,
    status,
    statusValue
}: UserBudgetFormProps) => {
    if (!createdBy) return null;

    return (
        <>
            {createdBy && (
                <div className="mb-2 row">
                    <label className="col-md-3 col-form-label">Creado Por</label>
                    <div className="col-md-9">
                        <input
                            type="text"
                            className="form-control"
                            readOnly
                            disabled
                            value={createdBy}
                        />
                    </div>
                </div>
            )}

            {createdAt && (
                <div className="mb-2 row">
                    <label className="col-md-3 col-form-label">Creado</label>
                    <div className="col-md-9">
                        <input
                            type="text"
                            className="form-control"
                            readOnly
                            disabled
                            value={momentParseDate(createdAt)}
                        />
                    </div>
                </div>
            )}

            {updatedBy && (
                <div className="mb-2 row">
                    <label className="col-md-3 col-form-label">Editado Por</label>
                    <div className="col-md-9">
                        <input
                            type="text"
                            className="form-control"
                            readOnly
                            disabled
                            value={updatedBy}
                        />
                    </div>
                </div>
            )}

            {updatedAt && (
                <div className="mb-2 row">
                    <label className="col-md-3 col-form-label">Actualizado</label>
                    <div className="col-md-9">
                        <input
                            type="text"
                            className="form-control"
                            readOnly
                            disabled
                            value={momentParseDate(updatedAt)}
                        />
                    </div>
                </div>
            )}
            <div className="mb-2 row">
                <label className="col-md-3 col-form-label">Estado</label>
                <div className="col-md-9">
                    <input
                        type="text"
                        className="form-control"
                        readOnly
                        disabled
                        value={status || statusValue || '-'}
                    />
                </div>
            </div>
        </>
    );
};

export default DefaultCreatedModifiedUserForm;
